import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

// Note: Replace this with your actual logo import
import logo from "../components/assets/img/AYVVA_BLACK _LOGO.png";

const Footer = () => {
  return (
    <footer className="bg-gray-50 text-gray-900 pt-8 sm:pt-12 border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-6 lg:gap-8">
          {/* Logo and About */}
          <div className="lg:col-span-3 text-center sm:text-left">
            <img
              src={logo}
              alt="Ayvva Logo"
              className="w-[123px] h-[81px] object-contain mx-auto sm:mx-0 mb-3"
            />
            <p
              className="text-xs font-light text-justify"
              style={{ fontFamily: "Poppins" }}
            >
              At Ayvva we bring you timeless fashion with a commitment to
              quality and sustainability. Explore our premium collections
              crafted for style and comfort.
            </p>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h6
              className="text-base font-normal mb-3 text-justify"
              style={{ fontFamily: "Playfair Display" }}
            >
              Quick Links
            </h6>
            <ul
              className="space-y-1 text-xs font-light"
              style={{ fontFamily: "Poppins" }}
            >
              <li>
                <Link
                  to="/men"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Men
                </Link>
              </li>
              <li>
                <Link
                  to="/women"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Women
                </Link>
              </li>
              <li>
                <Link
                  to="/new-arrivals"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link
                  to="/best-seller"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Sale
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Collections
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div className="lg:col-span-2">
            <h6
              className="text-base font-normal mb-3 text-justify"
              style={{ fontFamily: "Playfair Display" }}
            >
              Customer Service
            </h6>
            <ul
              className="space-y-1 text-xs font-light"
              style={{ fontFamily: "Poppins" }}
            >
              {/* <li><Link to="/" className="text-gray-900 hover:text-gray-600 transition-colors no-underline">FAQs</Link></li> */}
              <li>
                <Link
                  to="/shipping-delivery"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Shipping & Delivery
                </Link>
              </li>
              <li>
                <Link
                  to="/return-exchange"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-policy"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Refund Policy
                </Link>
              </li>
              {/* <li><Link to="/" className="text-gray-900 hover:text-gray-600 transition-colors no-underline">Order Tracking</Link></li> */}
              <li>
                <Link
                  to="/contact-us"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Info */}
          <div className="lg:col-span-2">
            <h6
              className="text-base font-normal mb-3 text-justify"
              style={{ fontFamily: "Playfair Display" }}
            >
              Company Info
            </h6>
            <ul
              className="space-y-1 text-xs font-light"
              style={{ fontFamily: "Poppins" }}
            >
              <li>
                <Link
                  to="/about"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Careers
                </Link>
              </li>
              {/* <li><Link to="/" className="text-gray-900 hover:text-gray-600 transition-colors no-underline">Sustainability</Link></li> */}
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-gray-900 hover:text-gray-600 transition-colors no-underline"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-3">
            <h6
              className="text-base font-normal mb-3 text-justify"
              style={{ fontFamily: "Playfair Display" }}
            >
              Contact Information
            </h6>
            <ul
              className="space-y-1 text-xs font-light"
              style={{ fontFamily: "Poppins" }}
            >
              {/* <li>
                                <span className="font-medium" style={{ fontFamily: 'Poppins' }}>Head Office Address:</span> E-155, 1st floor , Lajpat Nagar 1 . New Delhi 110024
                            </li> */}
              <li>
                <span className="font-medium" style={{ fontFamily: "Poppins" }}>
                  Email:
                </span>{" "}
                contact@ayvva.com
              </li>
              <li>
                <span className="font-medium" style={{ fontFamily: "Poppins" }}>
                  Phone:
                </span>{" "}
                +91- 9582111007
              </li>
              <li>
                <span className="font-medium" style={{ fontFamily: "Poppins" }}>
                  WhatsApp:
                </span>{" "}
                <a
                  href="https://wa.me/919582111007"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black hover:underline"
                >
                  +91-9582111007
                </a>
              </li>

              {/* <li>
                                <span className="font-medium" style={{ fontFamily: 'Poppins' }}>Hours:</span> Mon–Sat: 9 AM–9 PM
                            </li>
                            <li>Cash On Delivery Available</li> */}
            </ul>
          </div>
        </div>

        {/* Subscription & Socials */}
        <div className="mt-8 sm:mt-12">
          <div className="max-w-2xl mx-auto text-center">
            <div className="flex justify-center items-center gap-4 mb-3">
              <Link
              to="https://www.facebook.com/share/19165ywHsU/?mibextid=wwXIfr"
                className="text-gray-900 hover:text-gray-600 transition-colors text-xl"
                >
                <FaFacebook />
              </Link>
              <Link
                to="https://www.instagram.com/ayvvainternational?igsh=anhxcWFya2lmcHQ5"
                className="text-gray-900 hover:text-gray-600 transition-colors text-xl"
              >
                <FaInstagram />
              </Link>
             
            </div>
            {/* <p className="mb-3 text-xs sm:text-sm" style={{ fontFamily: 'Poppins' }}>
                            Email Subscription for Offers & Newsletters
                        </p>
                        <form className="flex flex-col sm:flex-row justify-center gap-2 px-4">
                            <input
                                type="email"
                                className="flex-1 sm:max-w-md px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-gray-400 text-sm"
                                placeholder="Enter your email"
                            />
                            <button className="bg-gray-900 text-white px-6 py-2 rounded hover:bg-gray-800 transition-colors font-medium text-sm">
                                SUBSCRIBE
                            </button>
                        </form> */}
          </div>
        </div>

        {/* Footer Bottom */}
        <div
          className="text-center mt-8 pt-4 border-t border-gray-200 pb-4 text-xs"
          style={{ fontFamily: "Poppins" }}
        >
          Made with love in India, powered by{" "}
          <Link
            to="https://squibfactory.com/"
            className="font-bold text-gray-900 hover:text-gray-600 transition-colors"
          >
            Squibfactory
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
